import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";

export default function MediaPicker({ open, onClose, onSelect }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get("/admin/media").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm" data-testid="media-picker-modal">
      <div className="glass-strong flex max-h-[80vh] w-full max-w-3xl flex-col rounded-3xl p-6">
        <div className="mb-5 flex items-center justify-between">
          <h3 className="font-display text-lg font-bold text-white">Media Library</h3>
          <button onClick={onClose} aria-label="Close" data-testid="media-picker-close" className="glass flex h-9 w-9 items-center justify-center rounded-full text-neutral-400 hover:text-white">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="grid flex-1 grid-cols-3 gap-3 overflow-y-auto sm:grid-cols-4">
          {loading && <p className="col-span-full py-10 text-center text-sm text-neutral-500">Loading…</p>}
          {!loading && items.length === 0 && (
            <p className="col-span-full py-10 text-center text-sm text-neutral-500">
              No media yet — upload files from the Media Library page.
            </p>
          )}
          {items.map((m) => (
            <button
              key={m.id}
              type="button"
              onClick={() => onSelect(m)}
              data-testid={`media-pick-${m.id}`}
              className="group relative aspect-square overflow-hidden rounded-xl border border-white/10 transition-colors hover:border-white/40"
            >
              {m.type === "video" ? (
                <video src={mediaUrl(m.url)} muted preload="metadata" className="h-full w-full object-cover" />
              ) : (
                <img src={mediaUrl(m.url)} alt={m.filename} loading="lazy" className="h-full w-full object-cover" />
              )}
              <span className="absolute inset-x-0 bottom-0 truncate bg-black/60 px-2 py-1 text-[10px] text-neutral-300 opacity-0 backdrop-blur transition-opacity group-hover:opacity-100">
                {m.filename}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
